import { Box, type BoxProps } from "@chakra-ui/react";

export const Section = ({ children, ...rest }: BoxProps) => (
  <Box as="section" maxW="maxw" mx="auto" px="pad" pb="sec" {...rest}>
    {children}
  </Box>
);
